import * as React from 'react';
import { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/flame/Modal';
import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { ReportDatePicker } from './ReportDatePicker';
import { serveCSV } from './serveCSV';
import { REPORT_TYPE } from './types';
import { StyledModal } from './ReportModal.style';

interface ReportModalProps {
  open: boolean;
  handleClose: () => void;
  type: REPORT_TYPE;
}

const ReportModal: React.FC<ReportModalProps> = ({ open, handleClose, type }) => {
  const [isOpen, setIsOpen] = React.useState(open);
  const [dates, setDates] = React.useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const closeModal = () => handleClose();

  const handleDates = (receivedDates: TSFixMe) => {
    setDates(receivedDates);
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      data-test="report-modal"
      className="mtd-report-modal"
    >
      <ModalHeader onCloseClicked={closeModal}>{type} Digital VAT Accounting Report</ModalHeader>

      <ModalBody>
        <Text mb={3}>Choose the report date range</Text>
        <ReportDatePicker handleDates={handleDates} />
      </ModalBody>

      <ModalFooter>
        <Flex justifyContent="flex-end">
          <Button data-test="cancel-button" mr={2} onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button
            fill
            variant="secondary"
            loading={isSubmitting}
            data-test="get-report-button"
            onClick={() => {
              setIsSubmitting(true);
              return serveCSV(type, dates).then(() => {
                closeModal();
                setIsSubmitting(false);
              });
            }}
          >
            Get Report
          </Button>
        </Flex>
      </ModalFooter>
    </StyledModal>
  );
};

export { ReportModal };
